import { CurrencyCode } from '@99designs/i18n';
import type { RelatedProduct } from '../types';

export type RelatedProductNames =
    | 'bronze-logo-contest'
    | 'bronze-logo-brand-identity-pack-contest'
    | 'bronze-logo-brand-guide-contest'
    | 'bronze-logo-social-media-pack-contest'
    | 'bronze-logo-business-card-contest'
    | 'brochure-essential'
    | 'business-card-essential'
    | 'postcard-flyer-essential';

export const getRelatedProductsByKey = (key: RelatedProductNames): RelatedProduct => {
    const relatedProducts: Record<string, RelatedProduct> = {
        'bronze-logo-contest': {
            name: 'bronze-logo-contest',
            title: __('Logo design'),
            url: '/logo-design/details',
            description: __('An unforgettable logo crafted for your brand'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/logo-design.jpeg',
                alt: __(
                    "A logo created for a sailing club with a salt shaker in the shape of a skull that has a banana it it's mouth"
                ),
                designerAttribution: { text: 'GS | Designs', userId: '977680' },
            },
            marketingKey: 'logo-design',
        },

        'bronze-logo-brand-identity-pack-contest': {
            name: 'bronze-logo-brand-identity-pack-contest',
            title: __('Logo & brand identity pack'),
            url: '/brand-identity-pack/details',
            description: __('A logo plus digital and print essentials to kick-start your brand'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/brand-identity-pack.jpeg',
                alt: __(
                    'A logo and brand identity pack created for a brownie company including a logo, business cards, a letterhead, an envelope, and a Facebook cover'
                ),
                designerAttribution: { text: 'Satryo', userId: '3100340' },
            },
            marketingKey: 'logo-brand-identity-pack',
        },

        'bronze-logo-brand-guide-contest': {
            name: 'bronze-logo-brand-guide-contest',
            title: __('Logo & brand guide'),
            url: '/logo-brand-guide/details',
            description: __(
                'Extend your logo design into a real brand with matching fonts, colors and style'
            ),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/logo-brand-guide.jpeg',
                alt: __('A minimalist logo design and a brand guide showing primary brand colors'),
                designerAttribution: { text: 'Iris Design', userId: '2778758' },
            },
            marketingKey: 'logo-brand-guide',
        },

        'bronze-logo-social-media-pack-contest': {
            name: 'bronze-logo-social-media-pack-contest',
            title: __('Logo & social media pack'),
            url: '/social-media-pack/details',
            description: __('Logo and social media cover images to make an impression online'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/social-media-pack.jpeg',
                alt: __('A logo and different versions of social media banners using that logo'),
                designerAttribution: { text: 'Suparde', userId: '3004243' },
            },
            marketingKey: 'logo-social-media-pack',
        },

        'bronze-logo-business-card-contest': {
            name: 'bronze-logo-business-card-contest',
            title: __('Logo & business card'),
            url: '/logo-business-card-design/details',
            description: __('A logo and business card design that pair perfectly'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/logo-business-card-design.jpeg',
                alt: __('A logo and a stack of business cards using that logo'),
                designerAttribution: { text: 'artsigma', userId: '1284917' },
            },
            marketingKey: 'logo-business-card-design',
        },

        'brochure-essential': {
            name: 'brochure-essential',
            title: __('Brochure'),
            url: '/brochure-essential/details',
            description: __('A custom brochure designed for your business'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/brochure-essential.jpg',
                alt: __(
                    'Two brochures next to each other, one is open to show the inside, with neutral colors and pictures of families'
                ),
                designerAttribution: { text: '.D.A.', userId: '3255762' },
            },
            marketingKey: 'brochure-design',
        },

        'business-card-essential': {
            name: 'business-card-essential',
            title: __('Business card'),
            url: '/business-card-essential/details',
            description: __('A unique business card designed to build connections'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/business-card-essential.jpg',
                alt: __(
                    'A stack of business cards with the back design facing upwards and single business card showing the front design'
                ),
                designerAttribution: { text: 'Vulcan.', userId: '3208755' },
            },
            marketingKey: 'business-card-design',
        },

        'postcard-flyer-essential': {
            name: 'postcard-flyer-essential',
            title: __('Postcard/Flyer'),
            url: '/postcard-flyer-essential/details',
            description: __('A custom postcard or flyer designed to reach your customers'),
            price: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            image: {
                src: 'https://99designs-start-static.imgix.net/product-details/related-products/postcard-flyer-essential.jpg',
                alt: __('A flyer showing discounts for a sweets business'),
                designerAttribution: { text: 'MRG', userId: '306263' },
            },
            marketingKey: 'postcard-flyer-design',
        },
    };
    return relatedProducts[key];
};
